import React from "react";
import { Helmet } from "react-helmet-async";

export const Seo = ({
  title,
  description,
  path = "/",
  image = "https://customer-assets.emergentagent.com/job_invest-bengaluru-1/artifacts/tgbhcusp_My%20Hoom%20Logo.pdf",
  jsonLd,
}) => {
  const fullTitle = title.includes("My Hoom") ? title : `${title} · My Hoom`;
  const url = `https://myhoom.in${path}`;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
};

export const LOCAL_BUSINESS_JSONLD = {
  "@context": "https://schema.org",
  "@type": "RealEstateAgent",
  "name": "My Hoom",
  "url": "https://myhoom.in",
  "description": "Premium real estate advisory and investment platform across Bengaluru and Dubai.",
  "telephone": "+91-9008683300",
  "email": "help@myhoom.in",
  "areaServed": [
    { "@type": "City", "name": "Bengaluru" },
    { "@type": "City", "name": "Dubai" },
  ],
  "sameAs": [
    "https://instagram.com/",
    "https://linkedin.com/",
    "https://youtube.com/",
  ],
};

export default Seo;
